"use client";

import { useEffect } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebaseConfig";
import { updateDeveloper, userUpdateFCM } from "../utils/API";

export default function FCMPermission() {


  useEffect(() => {
    // 🚫 Skip on login page
    if (window.location.pathname === "/login") {
      console.log("Login page skip FCM process.")
      return;
    }

    const authData = JSON.parse(
      localStorage.getItem("authData") || "{}"
    );

    const userId = authData?.user?._id;

    // 🚫 Skip if not logged in
    if (!userId) {
      console.warn("⚠️ No userId found. Skipping FCM init.");
      return;
    }

    console.log("🔐 User logged in — initializing FCM...");
    initFCM(userId);

    if (!messaging) return;

    const unsubscribe = onMessage(messaging, (payload) => {
      console.log("📩 Message received:", payload);

      if (payload.notification) {
        const { title, body } = payload.notification;
        if (title && body) new Notification(title, { body });
      }
    });

    return () => unsubscribe();
  }, []);

  const initFCM = async (userId: string) => {
    try {
      if (!messaging) return;

      if (Notification.permission !== "granted") {
        await requestPermission(userId);
        return;
      }

      await saveToken(userId);
    } catch (error) {
      console.error("❌ Error initializing FCM:", error);
    }
  };

  const requestPermission = async (userId: string) => {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    await saveToken(userId);
  };

  const saveToken = async (userId: string) => {
    const fcmToken = await getToken(messaging!, {
      vapidKey:
        "BGh88OWY5_KXCRNV2AGHC5qnsG90nkEnY-Chc-HxZ47rBtIab2-69aGz1MSGMCXkTR1Aq1r-ycNXM54nfNysylk",
    });

    if (!fcmToken) return;

    // console.log("✅ Got FCM Token:", fcmToken);

    const authData = JSON.parse(
      localStorage.getItem("authData") || "{}"
    );

    const roleId = authData?.roleId;

    const formData = new FormData();
    formData.append("id", userId);
    formData.append("fcmToken", fcmToken);

    const deviceType = /Mobi|Android/i.test(navigator.userAgent)
      ? "mobile"
      : "desktop";

    const tokenPayload = {
      token: fcmToken,
      device: deviceType,
    };

    await userUpdateFCM(userId, fcmToken);

  };

  return null;
}